import * as React from "react";

function SvgIcReminder(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6a1 1 0 112 0c0 .534.326 1.08.909 1.276 1.282.432 2 1.348 2.432 2.562.447 1.258.552 2.747.614 4.163.025.569.495.999 1.045.999a1 1 0 110 2H6a1 1 0 110-2c.55 0 1.02-.43 1.045-1 .062-1.415.167-2.904.614-4.162.432-1.214 1.15-2.13 2.432-2.562C10.674 7.08 11 6.534 11 6zm1-3a3 3 0 00-2.965 2.538c-1.754.736-2.726 2.128-3.26 3.63-.461 1.298-.615 2.728-.69 3.974A3.001 3.001 0 006 19h2.385a3.752 3.752 0 007.23 0H18a3 3 0 00.914-5.858c-.074-1.246-.228-2.676-.689-3.973-.534-1.503-1.506-2.895-3.26-3.63A3 3 0 0012 3zm2.016 16H9.984a2.25 2.25 0 004.032 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcReminder;
